import type {
  Payment as GraphQlPayment,
  RefundInvoice,
} from '~/api/graphql/generated/types'
import type { Payment } from '~/types'

export enum RefundFlowState {
  ISSUE_REFUND = 'ISSUE_REFUND',
  REFUND_PROCESSING = 'REFUND_PROCESSING',
  REFUND_SUCCESS = 'REFUND_SUCCESS',
}

export enum RefundMethod {
  CREDIT_DEBIT = 'CREDIT_DEBIT',
  CARECREDIT = 'CARECREDIT',
  CASH = 'CASH',
  CHECK = 'CHECK',
}

export interface RefundDialogContextType {
  actions: {
    cancelTransaction: () => void
    clearRefundError: () => void
    resetDialog: () => void
    setRefundAmount: (amount: number) => void
    setRefundError: (error: {
      message: string
      severity: 'error' | 'warning'
      status: number
    }) => void
    setSelectedPayment: (payment: GraphQlPayment | Payment | null) => void
    setState: (state: RefundFlowState) => void
    submitManualRefund: (currentDialogState: RefundDialogStateType) => void
  }
  dialogState: RefundDialogStateType
  isLoading: boolean
  refundInvoice: RefundInvoice
}

export interface RefundDialogStateType {
  currentState: RefundFlowState
  hasPartialRefund: boolean
  partialRefundAmount: number
  refundAmount: number
  refundError: {
    message: string
    severity: 'error' | 'warning'
    status: number
  } | null
  selectedPayment: (GraphQlPayment | Payment) | null
}
